export { ArticlesPage as default } from '@/components/pages/Ir/Stock/Articles'
